import { render, staticRenderFns } from "./RecipientsLoader.vue?vue&type=template&id=2161248c&scoped=true&lang=pug"
import script from "./RecipientsLoader.vue?vue&type=script&lang=js"
export * from "./RecipientsLoader.vue?vue&type=script&lang=js"
import style0 from "./RecipientsLoader.vue?vue&type=style&index=0&id=2161248c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161248c",
  null
  
)

export default component.exports